function initCarousel() {
    if (typeof gsap === 'undefined' || typeof Draggable === 'undefined') {
        setTimeout(initCarousel, 50);
        return;
    }

    gsap.registerPlugin(Draggable);

    if (typeof CustomEase !== 'undefined') {
        gsap.registerPlugin(CustomEase);
        try {
            CustomEase.create("ease-out", "0,0,.58,1");
        } catch (e) {}
    }

    function initAllCarousels() {
        document.querySelectorAll(".wp-block-bmg-page-carousel").forEach(block => {
            const track = block.querySelector(".wrapper");
            const slides = block.querySelectorAll(".item");

            if (!track || slides.length === 0) {
                return;
            }

            const gap = parseFloat(getComputedStyle(track).gap) || 0;
            const slideWidth = slides[0].offsetWidth + gap;

            if (slideWidth === 0 || isNaN(slideWidth)) {
                return;
            }

            const startPosition = 0;
            const endPosition = -(slides.length - 1) * slideWidth;

            function setActiveSlide(x) {
                const index = Math.round(Math.abs(x) / slideWidth);

                slides.forEach((slide, i) => {
                    const img = slide.querySelector(".item-img");
                    const data = slide.querySelector(".item-data");
                    const p = data ? data.querySelector("p") : null;

                    if (!img || !data || !p) {
                        return;
                    }

                    if (i === index) {
                        slide.classList.add("is-active");

                        const offsetY = p.offsetHeight;
                        img.style.setProperty('--offset-y', `${offsetY}px`);

                        gsap.to(data, { 
                            y: -offsetY, 
                            duration: 0.4, 
                            ease: "ease-out",
                        });
                    } else {
                        slide.classList.remove("is-active");

                        gsap.to(data, { 
                            y: 0, 
                            duration: 0.4, 
                            ease: "ease-out",
                        });
                    }
                });
            }

            setActiveSlide(0);

            gsap.set(track, { x: 0 });

            Draggable.create(track, {
                type: "x",
                bounds: { minX: endPosition, maxX: startPosition },
                edgeResistance: 0.9,
                cursor: "grab",
                activeCursor: "grabbing",
                inertia: true,
                snap: (val) => Math.round(val / slideWidth) * slideWidth,
                onDragEnd: function () {
                    const snappedX = Math.round(this.x / slideWidth) * slideWidth;
                    gsap.to(track, {
                        x: snappedX,
                        duration: 0.2,
                        ease: "power2.out",
                        onComplete: () => setActiveSlide(snappedX),
                    });
                },
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllCarousels);
    } else {
        initAllCarousels();
    }
}

initCarousel();
